import {
  CheckoutSession,
  deleteCheckoutSessionByCheckoutSessionId,
  getCheckoutSessionById,
} from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { useCheckoutSession } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useCheckoutSession';
import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { Text } from '@/components/shared/components/Text';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

interface CancelCheckoutSessionDialogProps {
  checkoutSession: CheckoutSession;
  opened: boolean;
  setOpened: (opened: boolean) => void;
  toggleDialog: () => void;
}

export const CancelCheckoutSessionDialog = ({
  checkoutSession,
  opened,
  setOpened,
  toggleDialog,
}: CancelCheckoutSessionDialogProps) => {
  const { request } = useRequest();
  const { revalidate } = useCache(getCheckoutSessionById, { checkoutSessionId: checkoutSession.id });
  const { refreshCheckoutSessionAndPaymentMethodEntities } = useCheckoutSession();

  const [loading, setLoading] = useState<boolean>(false);

  const onSubmitCancel = async () => {
    setLoading(true);
    await request(deleteCheckoutSessionByCheckoutSessionId, { checkoutSessionId: checkoutSession.id });
    await revalidate();
    setTimeout(async () => {
      await refreshCheckoutSessionAndPaymentMethodEntities();
      toggleDialog();
      setLoading(false);
    }, 1000);
  };

  return (
    <ActionDialog
      loading={loading}
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      Title={<Text tId={'CANCEL_CHECKOUT_SESSION'} />}
      MainButton={<Text tId={'CANCEL_CHECKOUT_SESSION_SHORT'} />}
      CloseButton={<Text tId={'CLOSE'} />}
      Description={<Text tId={'CANCEL_CHECKOUT_SESSION_DESCRIPTION'} />}
      onSubmit={onSubmitCancel}
    />
  );
};
